<template>
  <div class="notifications">
    <BaseToast
      v-for="(item, index) in items"
      :key="index"
      :title="item.title"
      :message="item.message"
      :time="item.time"
    />
  </div>
</template>
<script>
export default {
    name: 'Notifications',
    computed: {
        items() {
            return this.$store.state.notifications.items;
        },
    },
};
</script>
<style lang="scss">
.notifications{
    position: fixed;
    top: 0;
    right: 0;
    margin: 80px 20px;
    z-index: 9999;
}
</style>
